// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__4SEhr","disabled":"FileBtn_disabled__2Qq7a","warn":"FileBtn_warn__2Qy3s","fade":"FileBtn_fade__32oE8"};